module.exports = __webpack_public_path__ + "fonts/quicksand-latin-400-normal.706547b.woff";